__turbopack_context__.v({
  "bottomBar": "vAqsWa_bottomBar",
  "contact": "vAqsWa_contact",
  "footer": "vAqsWa_footer",
  "iconYoutube": "vAqsWa_iconYoutube",
  "info": "vAqsWa_info",
  "infoItems": "vAqsWa_infoItems",
  "link": "vAqsWa_link",
  "linkContainer": "vAqsWa_linkContainer",
  "links": "vAqsWa_links",
  "linksAndNewsletter": "vAqsWa_linksAndNewsletter",
  "locales": "vAqsWa_locales",
  "locationItems": "vAqsWa_locationItems",
  "locationTitle": "vAqsWa_locationTitle",
  "locations": "vAqsWa_locations",
  "logoLink": "vAqsWa_logoLink",
  "mainContent": "vAqsWa_mainContent",
  "navItem": "vAqsWa_navItem",
  "navItems": "vAqsWa_navItems",
  "navLink": "vAqsWa_navLink",
  "newsletter": "vAqsWa_newsletter",
  "socialItem": "vAqsWa_socialItem",
  "socialItemIcon": "vAqsWa_socialItemIcon",
  "socialLink": "vAqsWa_socialLink",
  "title": "vAqsWa_title",
});
